import React from 'react';

import styled from '@emotion/styled';
import { Badge } from '@lightspeed/flame/Badge';
import { FlameTheme } from '@lightspeed/flame/Core';
import { IconClose } from '@lightspeed/flame/Icon/Close';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import { createReactRenderer } from 'helpers/react-renderer';

interface SavedCardsHeaderProps {
  hideSavedCardsTooltip: boolean;
}

const TOOLTIP_PREF_TYPE = 'view';
const TOOLTIP_PREF_NAME = 'saved_cards_tooltip_hide';
const TOOLTIP_COMPONENT = 'customer.views.customer';

const TooltipHeaderText = styled(Text)`
  font-size: 18px;
  margin-bottom: 14px;
`;

const TooltipText = styled(Text)`
  font-weight: normal;
  font-size: 14px !important;
`;

const StyledBadge = styled(Badge)`
  cursor: help;
`;

const StyledTooltip = styled(Tooltip)`
  padding: 10px;
`;

const SavedCardsHeader: React.FC<SavedCardsHeaderProps> = ({ hideSavedCardsTooltip }) => {
  const [tooltipActive, setTooltipActive] = React.useState<boolean | undefined>(
    !hideSavedCardsTooltip
  );

  const [renderTooltipAndLabel, setRenderTooltipAndLabel] = React.useState<boolean>(true);

  // This hack is needed to force a re-render of the tooltip and label after the user closes the tooltip.
  const forceRefresh = () => {
    setRenderTooltipAndLabel(false);
    setTimeout(() => {
      setRenderTooltipAndLabel(true);
    }, 0);
  };

  return (
    <FlameTheme>
      <div>
        {/* Placeholder for Saved Cards Header content */}
        Saved Payment Methods
        {renderTooltipAndLabel ? (
          <div style={{ float: 'right', padding: '0px', marginTop: '-3px' }}>
            <StyledTooltip
              // @ts-ignore
              content={
                <div style={{ maxWidth: '300px' }}>
                  {tooltipActive && (
                    <div>
                      <button
                        type="button"
                        style={{
                          float: 'right',
                          background: 'none',
                          border: 'none',
                          padding: 0,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={(e) => {
                          e.preventDefault();

                          window.lsCloud.UserPreferences.save(
                            TOOLTIP_PREF_TYPE,
                            TOOLTIP_COMPONENT,
                            TOOLTIP_PREF_NAME,
                            'true'
                          );

                          setTooltipActive(false);
                          forceRefresh();
                        }}
                      >
                        <IconClose color="#fff" />
                      </button>
                    </div>
                  )}
                  <TooltipHeaderText>Saved Payment Methods</TooltipHeaderText>
                  <TooltipText>
                    Save your customer&#39;s payment methods onto their profile for future purchases
                  </TooltipText>
                </div>
              }
              active={tooltipActive}
            >
              <StyledBadge type="success">New</StyledBadge>
            </StyledTooltip>
          </div>
        ) : (
          <div />
        )}
      </div>
    </FlameTheme>
  );
};

const RenderedComponent = createReactRenderer({
  component: SavedCardsHeader,
  selector: '[data-react-root="SavedCardsHeader"]',
});

history.onChangeState(
  [
    {
      name: ['customer.views.customer'],
      form_name: 'view',
      tab: ['details'],
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
